module.exports = __webpack_public_path__ + "img/15_003.39cdd87e.webp";